import styled from "styled-components";
import { Link } from "react-router-dom";

const ContentLeft = styled.div`
  width: 90%;
  padding:2em;
  text-align: left;
  color: black;
  padding-top:0px;
  text-decoration: none;
  a {
    text-decoration: none;
  }
  a:hover {
        color:#cc33cc;
  }
  a:visited {
    color: #3333cc;
  }
`;

const Miscellanious = () => {
    return(
      <ContentLeft>
        <Link to="/drawingClub">This way to drawing club (under contruction)</Link>
      </ContentLeft>
    );
  };
  
  export default Miscellanious;